export default "__VITE_ASSET__CunxzLe$__"